import React, { useEffect, useState } from "react";
import { api, money } from "@/lib/api";
import { Trophy, Clock, Flag, Crown } from "lucide-react";

const TABS = [
  { id: "top", label: "Top", icon: Crown },
  { id: "recent", label: "Recent", icon: Clock },
  { id: "first", label: "First", icon: Flag },
];

const fmtDate = (iso) => { try { return new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric" }); } catch { return ""; } };

export default function SupporterLeaderboard({ campaignId }) {
  const [data, setData] = useState(null);
  const [tab, setTab] = useState("top");

  useEffect(() => {
    api.get(`/campaigns/${campaignId}/leaderboard`).then((r) => setData(r.data)).catch(() => setData({ top: [], recent: [], first: [] }));
  }, [campaignId]);

  const rows = (data && data[tab]) || [];
  const hasAny = data && (data.top.length || data.recent.length || data.first.length);
  if (data && !hasAny) return null;

  return (
    <div className="rounded-2xl border border-ff-border bg-white p-5 shadow-sm" data-testid="supporter-leaderboard">
      <div className="flex items-center gap-2 font-heading text-sm font-bold text-ff-blue">
        <Trophy className="h-4 w-4 text-ff-amber" /> Supporters
      </div>
      <div className="mt-3 grid grid-cols-3 gap-1 rounded-lg bg-[#F3F4F6] p-1">
        {TABS.map((t) => (
          <button key={t.id} onClick={() => setTab(t.id)} data-testid={`lb-tab-${t.id}`}
            className={`flex items-center justify-center gap-1 rounded-md py-1.5 text-xs font-bold transition-colors duration-200 ${tab === t.id ? "bg-white text-ff-blue shadow-sm" : "text-ff-medium"}`}>
            <t.icon className="h-3.5 w-3.5" /> {t.label}
          </button>
        ))}
      </div>
      <ol className="mt-3 space-y-2" data-testid="lb-list">
        {rows.length === 0 ? (
          <li className="py-3 text-center text-xs text-ff-medium">No supporters yet.</li>
        ) : rows.map((r, i) => (
          <li key={i} className="flex items-center justify-between gap-2" data-testid={`lb-row-${tab}-${i}`}>
            <div className="flex min-w-0 items-center gap-2">
              <span className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs font-bold ${tab === "top" && i < 3 ? "bg-ff-amber text-white" : "bg-[#F3F4F6] text-ff-medium"}`}>{i + 1}</span>
              <span className="truncate text-sm font-semibold text-ff-blue">{r.name}</span>
            </div>
            <span className="shrink-0 text-sm font-bold text-ff-green">
              {r.amount != null ? money(r.amount) : <span className="text-xs font-normal text-ff-medium">{fmtDate(r.date)}</span>}
            </span>
          </li>
        ))}
      </ol>
    </div>
  );
}
